var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"print"}},[_c('div',{staticClass:"PrintableComponent print-only q-pa-lg-md"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }